// eslint-disable-next-line jira/filename-case
import React from 'react';
import type { ForYouConfig } from '@atlassian/global-side-navigation/for-you-types';
import type { Filter } from '@atlassian/navigation-common/types';
import { MENU_ID_FOR_YOU } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { jiraHomeRoute } from '@jira/router-routes__jira-home-routes/src/jiraHomeRoute.tsx';
import { SkeletonNavMenuItems } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/skeleton-nav-menu-items/main.tsx';
import { AnalyticContextProvider as RecentAnalyticContextProvider } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-recent/src/common/controllers/analytic-context/index.tsx';
import { AnalyticContextProvider as StarredAnalyticContextProvider } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-starred/src/common/controllers/analytics-context/index.tsx';
import { FAVORITE_TYPE_FILTER_MAP } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-starred/src/common/constants.tsx';
import { useRecentItems } from './useRecentItems.tsx';
import { useStarredItems } from './useStarredItems.tsx';
import { recentFlyoutEntrypoint } from './recentFlyoutEntrypoint.entrypoint.tsx';
import { starredFlyoutEntrypoint } from './starredFlyoutEntrypoint.entrypoint.tsx';
import { RecentMenuLinkItemAdaptor } from './RecentMenuLinkItemAdaptor.tsx';
import type { JiraRecentOLFItem, JiraStarredOLFItem } from './JiraRecentOLFItem.types.tsx';
import { StarredMenuLinkItemAdaptor } from './StarredMenuLinkItemAdaptor.tsx';

type Params = {
	isForYouSelected: boolean;
	recentEntryPointParams?: Record<string, unknown>;
	starredEntryPointParams?: Record<string, unknown>;
	starredFilterConfig: Filter[];
};

export function getForYouConfig(
	params: Params,
): ForYouConfig<unknown, JiraRecentOLFItem, JiraStarredOLFItem> {
	const { isForYouSelected, recentEntryPointParams, starredEntryPointParams, starredFilterConfig } =
		params;

	return {
		forYouItem: {
			isSelected: isForYouSelected,
			menuItemId: MENU_ID_FOR_YOU,
			url: jiraHomeRoute.path,
		},
		recent: {
			entryPoint: recentFlyoutEntrypoint,
			entryPointParams: recentEntryPointParams,
			fallback: (
				<SkeletonNavMenuItems withHeading withSearch withSubHeading withSubTitle isFlyout />
			),
			isSearchable: true,
			ItemComponent: RecentMenuLinkItemAdaptor,
			menuItemId: 'jira.sidebar.recent',
			MenuContentWrapperComponent: RecentAnalyticContextProvider,
			useItems: useRecentItems,
			viewAllUrl: `${jiraHomeRoute.path}?viewed`,
		},
		starred: {
			entryPoint: starredFlyoutEntrypoint,
			entryPointParams: starredEntryPointParams,
			fallback: <SkeletonNavMenuItems withHeading withSearch isFlyout />,
			filterConfig: {
				filters: starredFilterConfig,
				defaultSelected: [FAVORITE_TYPE_FILTER_MAP.ALL],
				hideSelectedFilterTag: [FAVORITE_TYPE_FILTER_MAP.ALL],
			},
			isSearchable: true,
			ItemComponent: StarredMenuLinkItemAdaptor,
			menuItemId: 'jira.sidebar.starred',
			MenuContentWrapperComponent: StarredAnalyticContextProvider,
			useItems: useStarredItems,
			viewAllUrl: `${jiraHomeRoute.path}?starred`,
		},
	};
}
